module.exports = __webpack_public_path__ + "img/oops-device.9165ef7e.svg";